import Icon from "./icon";

import styles from "./app-error.module.css";

interface AppErrorProps {
  "data-testid"?: string;
  description: string;
  resolution: string;
}

function AppError({
  "data-testid": testId = "pallet-app-error",
  description,
  resolution,
}: AppErrorProps) {
  return (
    <div
      data-testid={testId}
      data-test-role="app-error"
      className={styles.pageError}
    >
      <div className={styles.errorPanel}>
        <div className={styles.errorIcon}>
          <Icon name="XOctagon" data-testid="error-icon" size={24} />
        </div>
        <div className={styles.content}>
          <div className={styles.card}>
            <h2 className={styles.errorHeaderText}>Something went wrong</h2>
            <p className={styles.errorText}>{description}</p>
          </div>

          <p className={styles.resolution}>{resolution}</p>
        </div>
      </div>
    </div>
  );
}

export default AppError;
